import { QrisDecodeUsecase } from '../../../usecase/fs-wallet-qris/qris-decode.usecase';
import { QrisPaymentUsecase } from '../../../usecase/fs-wallet-qris/qris-payment.usecase';
import { RequestPinUsecase } from '../../../usecase/fs-wallet-qris/request-pin.usecase';
import { ValidatePinUsecase } from '../../../usecase/fs-wallet-qris/validate-pin.usecase';


export const walletQrisUsecaseProvider = [
  QrisDecodeUsecase,
  QrisPaymentUsecase,
  RequestPinUsecase,
  ValidatePinUsecase
];
